import { SWRConfiguration } from "swr";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { partTypeTire } from "../constants/partTypes";
import { useDealerAccountInfo } from "../stores/hooks/useDealerAccountInfo";

export const useCheckNationalStockLevelByPartId = (
  partId: string,
  swrOptions: SWRConfiguration<FetcherResult<Payload>> = {}
): ModifiedSWRResponse<FetcherResult<Payload>, Payload> => {
  const { dealerId } = useDealerAccountInfo();

  const results = useSwrGet<Payload>(
    partId
      ? "/retailSiteWebService/parts/utility/checkNationalStockLevelByPartId.php"
      : null,
    {
      dealerId,
      partId,
      partOptionId: "0",
      partType: partTypeTire,
    },
    swrOptions
  );

  return results;
};

type Payload = {
  nationalStockTable: {
    manufacturerPartNumber: string;
    nationalPartNumber: string;
    nationalStockList: NationalStockListItem[];
  };
};

type NationalStockListItem = {
  locationCity: string;
  locationDistributorName: string;
  locationItemQty: string;
  locationMinutesSinceLastStockUpdate: number;
  locationName: string;
  locationPhone: string;
  locationState: string;
};
